import { useEffect, useState } from "react";
import { groupAR, parseAR } from "@/lib/money";

/** Fix BR (2026-11-03): campo de monto que muestra el punto de miles mientras se escribe ("1.500.000,50").
 * onChange recibe un número. Acepta coma para los centavos (máximo 2). */
export function MoneyInput({ value, onChange, disabled = false, testId, placeholder = "0", style }) {
  const [text, setText] = useState(() => groupAR(value));
  useEffect(() => {
    // Solo se reescribe si el valor cambió desde afuera (ej. SAC automático), no mientras se tipea.
    if (parseAR(text) !== (Number(value) || 0)) setText(groupAR(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const handle = (e) => {
    const raw = e.target.value.replace(/[^\d,]/g, "");
    const i = raw.indexOf(",");
    const intPart = (i >= 0 ? raw.slice(0, i) : raw).replace(/^0+(?=\d)/, "");
    const decPart = i >= 0 ? raw.slice(i + 1).replace(/,/g, "").slice(0, 2) : null;
    const shown = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (decPart !== null ? `,${decPart}` : "");
    setText(shown);
    onChange(parseAR(shown));
  };
  return (
    <input inputMode="decimal" value={text} onChange={handle} disabled={disabled} placeholder={placeholder}
      data-testid={testId} style={{ width: "100%", ...(disabled ? { background: "var(--invict-bone-2)" } : {}), ...style }} />
  );
}
